import commonService from './commonService'
import utils from './utils'

const getAll = async (signal = null) => {
  const url = utils.url + '/members'
  return await commonService.load(url, signal)
}

const get = async (id, signal = null) => {
  const url = `${utils.url}/members/${id}`
  return await commonService.load(url, signal, null)
}

const add = async (instance, signal = null) => {
  return await commonService.add('members', instance, signal)
}

const update = async (instance, signal = null) => {
  return await commonService.update('members', instance, signal)
}

const delete_ = async (instance, signal = null) => {
  return await commonService.delete_('members', instance.id, signal)
}

const getLastByOrgane = async (organeType, organeId, limit = 10, signal = null) => {
  const url = `${utils.url}/members/last/${limit}/${organeType}/${organeId}`
  return await commonService.load(url, signal, [])
}

const getAllByOrganeFromSo = async (
  organeType,
  organeId,
  offset = 0,
  limit = 10,
  signal = null,
) => {
  const url = `${utils.url}/members/fromso/${offset}-${limit}/${organeType}/${organeId}`
  return await commonService.load(url, signal, [])
}

const getAllByOrganeFromSoPattern = async (
  organeType,
  organeId,
  pattern,
  offset = 0,
  limit = 10,
  signal = null,
) => {
  const url = `${utils.url}/members/fromso/${offset}-${limit}/${organeType}/${organeId}/${pattern}`
  return await commonService.load(url, signal, [])
}

const getAllUnaffectedByPattern = async (pattern, offset = 0, limit = 10, signal = null) => {
  const url = `${utils.url}/members/unaffected/fromso/${offset}-${limit}/${pattern}`
  return await commonService.load(url, signal, [])
}

const getAllUnaffected = async (offset = 0, limit = 10, signal = null) => {
  const url = `${utils.url}/members/unaffected/fromso/${offset}-${limit}`
  return await commonService.load(url, signal, [])
}
/*
 ** Count members and group by the organe's children
 */
const countByOrganeAndPattern = async (organeType, organeId, pattern, signal = null) => {
  const url = `${utils.url}/members/count/${organeType}/${organeId}/${pattern}`
  return await commonService.load(url, signal, 0)
}

const countUnaffectedByPattern = async (pattern, signal = null) => {
  const url = `${utils.url}/members/count/unaffected/${pattern}`
  return await commonService.load(url, signal, 0)
}

const countUnaffected = async (signal = null) => {
  const url = `${utils.url}/members/count/unaffected`
  return await commonService.load(url, signal, 0)
}

const countAndGroupByOrgane = async (organeType, organeId, signal = null) => {
  const url = `${utils.url}/members/count-and-group/${organeType}/${organeId}`
  return await commonService.load(url, signal, [])
}

const countAllInYear = async (year, signal = null) => {
  const url = utils.url + '/members/count/years/' + year
  return await commonService.load(url, signal, [])
}

/*
 ** Count all entries and group by years, months and days
 */
const countAllLast = async (date, signal = null) => {
  const url = utils.url + '/members/count/all/' + date
  return await commonService.load(url, signal, {})
}

const countAllLastByOrgane = async (date, organeType, organeId, signal = null) => {
  const url = `${utils.url}/members/count/all/${date}/${organeType}/${organeId}`
  return await commonService.load(url, signal, {})
}

const countAllByOrgane = async (organeType, organeId, signal = null) => {
  const url = `${utils.url}/members/count/${organeType}/${organeId}`
  return await commonService.load(url, signal, {})
}

export default {
  getAll,
  get,
  countAllLast,
  countAndGroupByOrgane,
  countAllLastByOrgane,
  countAllByOrgane,
  countAllInYear,
  countByOrganeAndPattern,
  getLastByOrgane,
  getAllByOrganeFromSo,
  getAllByOrganeFromSoPattern,
  add,
  update,
  delete_,
  countUnaffected,
  countUnaffectedByPattern,
  getAllUnaffected,
  getAllUnaffectedByPattern,
}
